import React from "react";

interface DiecutCardSkeletonProps {
  viewMode: "grid" | "list";
}

export const DiecutCardSkeleton: React.FC<DiecutCardSkeletonProps> = ({
  viewMode,
}) => {
  return (
    <div
      className={`backdrop-blur-xl bg-white/70 dark:bg-gray-900/70 rounded-2xl border border-gray-200/50 dark:border-gray-700/50 shadow-xl overflow-hidden animate-pulse ${
        viewMode === "list" ? "flex flex-col md:flex-row" : ""
      }`}
    >
      {/* Image placeholder */}
      <div
        className={`bg-gray-200 dark:bg-gray-700 ${
          viewMode === "list" ? "md:w-64 h-48 md:h-auto" : "h-64"
        }`}
      />

      {/* Content */}
      <div className={`p-6 ${viewMode === "list" ? "flex-1" : ""}`}>
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-3" />
        <div className="space-y-2 mb-4">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
        </div>
        <div className="flex gap-2 mb-4">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-16" />
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-20" />
        </div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24" />
      </div>
    </div>
  );
};
